module.exports = __webpack_public_path__ + "img/pic-2.a6d82fcf.png";